function n(){var n=navigator.userAgent.match(/Line\/\d+(\.\d+)*/i);return n?n[0].slice(5):null}export{n as getLineVersion};
